const MILLIS = 1000;
const SECONDS_IN_MINUTE = 60;
const CODE_SEND_INTERVAL_SECONDS = 30;

export { CODE_SEND_INTERVAL_SECONDS, MILLIS, SECONDS_IN_MINUTE };
